var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CampaignTopBanner',{attrs:{"visible":_vm.standaloneCampaignBannerVisible}}),_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[_c('router-view')],1),_c('CampaignPromotions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }